import { IAddress } from '@/types';
import type { GetVacantUnitsDashboardTableRow } from 'types/responses';

function convertAddressToString(
  address:
    | IAddress
    | GetVacantUnitsDashboardTableRow['address']
    | null
    | undefined,
): string {
  if (!address) {
    return '';
  }
  return [
    address?.buildingNumber,
    address?.street,
    address?.city,
    address?.stateOrProvince,
    address?.postalCode,
    address?.country,
  ]
    .filter(Boolean)
    .join(', ');
}

export default convertAddressToString;
